import { MoreOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { TextLinkButton, styleVariables } from '@lib/common';
import { Popover, Space } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var KebabButton = styled(TextLinkButton).withConfig({
  displayName: "add-more-section-popovercomponent__KebabButton",
  componentId: "sc-192kmqr-0"
})(["width:10px !important;background:'green' !important;"]);
var StyledTextLinkButton = styled(TextLinkButton).withConfig({
  displayName: "add-more-section-popovercomponent__StyledTextLinkButton",
  componentId: "sc-192kmqr-1"
})(["color:", ";font-weight:500;line-height:24px;"], styleVariables.colors.blue4);
export var AddMoreSectionPopoverComponent = function AddMoreSectionPopoverComponent(_ref) {
  var section = _ref.section,
      onCreateSection = _ref.onCreateSection,
      labelTranslation = _ref.labelTranslation;
  var sectionId = section === null || section === void 0 ? void 0 : section.id.toString();

  var _useState = useState(),
      openPopoverSectionId = _useState[0],
      setOpenPopoverSectionId = _useState[1];

  var moreContent = function moreContent() {
    return /*#__PURE__*/_jsxs(Space, {
      direction: "vertical",
      children: [/*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick(e) {
          e.stopPropagation();
          onCreateSection(section.previousSectionId);
          setOpenPopoverSectionId('');
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: labelTranslation.addSectionAbove
      }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick(e) {
          e.stopPropagation();
          onCreateSection(section.id.toString());
          setOpenPopoverSectionId('');
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: labelTranslation.addSectionBelow
      })]
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Popover, {
      placement: "right",
      content: moreContent(),
      open: sectionId === openPopoverSectionId,
      onOpenChange: function onOpenChange() {
        var isPopOverVisible = sectionId === openPopoverSectionId;
        setOpenPopoverSectionId(isPopOverVisible ? '' : sectionId);
      },
      trigger: 'click',
      children: /*#__PURE__*/_jsx(KebabButton, {
        size: "large",
        icon: /*#__PURE__*/_jsx(MoreOutlined, {}),
        type: "text",
        shape: "circle",
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      })
    })
  });
};